module.exports = __webpack_public_path__ + "img/animals_owl.da21659e.png";